import { getFunnelVariant } from './anonymousSession';

export const trackEvent = (eventName, params = {}) => {
    const variant = params.funnel_variant || getFunnelVariant();
    const payload = variant ? { ...params, funnel_variant: variant } : params;
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
    } else {
        console.warn('[analytics] gtag not loaded, skipped:', eventName, payload);
    }
};